module.exports = __webpack_public_path__ + "static/media/marker-garage.e77fe151.svg";